import { render, staticRenderFns } from "./downCenter.vue?vue&type=template&id=52ddc103&scoped=true&"
import script from "./downCenter.vue?vue&type=script&lang=js&"
export * from "./downCenter.vue?vue&type=script&lang=js&"
import style0 from "./downCenter.vue?vue&type=style&index=0&id=52ddc103&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ddc103",
  null
  
)

export default component.exports